import DirectionsOutlined from "@mui/icons-material/DirectionsOutlined";
import StorefrontOutlined from "@mui/icons-material/StorefrontOutlined";
import { Box, Button, Card, Chip, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { FacilityPlaceResponse } from "@bw/shared/types";
import { businessWorkspaceUrl } from "../../../app/businessWorkspaceUrl";

export function CommunityPlaceCard({ place }: { place: FacilityPlaceResponse }) {
  const address = [
    place.address.line1,
    place.address.city,
    place.address.state,
    place.address.postal_code,
  ].filter(Boolean).join(", ");
  const directions = `https://www.google.com/maps/dir/?${new URLSearchParams({
    api: "1",
    destination: `${place.address.latitude},${place.address.longitude}`,
  }).toString()}`;
  const workspace = typeof window === "undefined" ? null : businessWorkspaceUrl(window.location.hostname);
  const claimUrl = workspace?.replace(/\/workspaces$/, `/places/${encodeURIComponent(place.place_id)}/claim`);

  return (
    <Card variant="outlined" sx={{ height: "100%", borderRadius: 3, p: 2.25 }}>
      <Stack spacing={1.5} sx={{ height: "100%" }}>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: "flex-start" }}>
          <Box sx={{ display: "grid", placeItems: "center", flex: "0 0 auto",
            width: 44, height: 44, borderRadius: 2.5, bgcolor: "action.hover",
            color: "text.secondary" }}>
            <StorefrontOutlined />
          </Box>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
              <Typography variant="h6">{place.name}</Typography>
              <Chip label={place.is_claimed ? "Claimed place" : "Unclaimed place"} size="small" variant="outlined" />
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {address}
            </Typography>
          </Box>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {place.is_claimed ? "Claimed by a business. Public details and services are still under review." : "Added by the community. Business details and services are not yet verified."}
        </Typography>
        <Box sx={{ mt: "auto" }}>
          <Button component={RouterLink} to={`/place/${place.place_id}`} size="small">View place</Button>
          <Button component="a" href={directions} target="_blank" rel="noreferrer"
            startIcon={<DirectionsOutlined />} size="small">
            Directions
          </Button>
          {!place.is_claimed && claimUrl ? <Button component="a" href={claimUrl} size="small">Claim this place</Button> : null}
        </Box>
      </Stack>
    </Card>
  );
}
